import { el, clear } from '../../utils/dom.js';
import { Maintenance } from '../../api/resources.js';
import { fmtDateTime, fmtMoney } from '../../utils/format.js';
import { statusBadge } from '../../components/badge.js';
import { openModal, confirm } from '../../components/modal.js';
import { field, readForm } from '../../components/form.js';
import { ok, err } from '../../components/toast.js';

export default async function MaintenanceDetailPage(outlet, ctx) {
  clear(outlet);
  const id = ctx.params.id;
  let m;
  try { m = await Maintenance.get(id); }
  catch (ex) { outlet.innerHTML = `<div class="empty">Error: ${ex.message}</div>`; return; }

  const canStart = m.status === 'pendiente';
  const canComplete = m.status === 'en_proceso';
  const canCancel = ['pendiente','en_proceso'].includes(m.status);

  outlet.appendChild(el('div', { class: 'page-head' },
    el('div', {},
      el('h1', {}, m.code),
      el('div', { class: 'muted' }, statusBadge(m.status), ' · ', m.type, ' · ', m.item_name || '—'),
    ),
    el('div', { class: 'flex gap-2 wrap' },
      el('a', { href: '#/maintenance', class: 'btn ghost' }, '← Volver'),
      canStart    ? el('button', { class: 'btn primary', onclick: start }, 'Iniciar') : null,
      canComplete ? el('button', { class: 'btn primary', onclick: openComplete }, 'Completar') : null,
      canCancel   ? el('button', { class: 'btn danger',  onclick: cancel }, 'Cancelar') : null,
    ),
  ));

  outlet.appendChild(el('div', { class: 'card' },
    el('div', { class: 'card-head' }, el('h3', {}, 'Detalles')),
    el('div', { style: 'display:grid;grid-template-columns:repeat(3,1fr);gap:var(--sp-3);' },
      kv('Equipo',     m.item_name),
      kv('Serial',     m.serial_number || m.unit_internal_code),
      kv('Tecnico',    m.technician),
      kv('Inicio',     m.start_date ? fmtDateTime(m.start_date) : '—'),
      kv('Fin',        m.end_date   ? fmtDateTime(m.end_date) : '—'),
      kv('Costo',      fmtMoney(m.cost)),
      kv('Proximo',    m.next_maintenance_date || '—'),
      kv('Descripcion', m.description || '—'),
      kv('Notas',      m.notes || '—'),
    ),
  ));

  function reload() { MaintenanceDetailPage(outlet, ctx); }

  async function start() {
    try { await Maintenance.start(id); ok('Mantenimiento iniciado'); reload(); }
    catch (ex) { err(ex.message); }
  }
  async function cancel() {
    const reason = prompt('Motivo:') || '';
    if (!await confirm({ title: 'Cancelar', message: '¿Cancelar este mantenimiento?', danger: true, confirmText: 'Cancelar' })) return;
    try { await Maintenance.cancel(id, reason); ok('Cancelado'); reload(); }
    catch (ex) { err(ex.message); }
  }
  function openComplete() {
    const form = el('form', {
      onsubmit: async (e) => {
        e.preventDefault();
        const d = readForm(form);
        try {
          await Maintenance.complete(id, {
            end_date: d.end_date ? new Date(d.end_date).toISOString() : undefined,
            cost: d.cost ? Number(d.cost) : undefined,
            next_maintenance_date: d.next_maintenance_date || undefined,
            notes: d.notes || undefined,
            return_unit_status: d.return_unit_status || undefined,
          });
          ok('Mantenimiento completado');
          modal.close();
          reload();
        } catch (ex) { err(ex.message); }
      },
    });
    form.append(
      field({ name: 'end_date', label: 'Fecha fin', type: 'datetime-local', value: toLocalInput(new Date()) }),
      field({ name: 'cost', label: 'Costo final', type: 'number', step: '0.01', value: m.cost }),
      field({ name: 'return_unit_status', label: 'Estado al devolver unidad', type: 'select', value: 'disponible',
        options: [
          { value: 'disponible', label: 'Disponible' },
          { value: 'danado', label: 'Danado' },
          { value: 'retirado', label: 'Retirado' },
        ]}),
      field({ name: 'next_maintenance_date', label: 'Proximo mantenimiento', type: 'date' }),
      field({ name: 'notes', label: 'Notas', type: 'textarea' }),
    );
    const cancelBtn = el('button', { class: 'btn', type: 'button', onclick: () => modal.close() }, 'Cancelar');
    const submit = el('button', { class: 'btn primary', type: 'submit' }, 'Completar');
    const modal = openModal({ title: 'Completar mantenimiento', body: form, footer: [cancelBtn, submit] });
  }
}

function kv(label, value) {
  return el('div', {},
    el('div', { class: 'text-xs muted' }, label),
    el('div', { class: 'text-bold' }, value || '—'),
  );
}
function toLocalInput(d) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
